const $ = window.jQuery;

const Nav = {
	init() {
		var $burger = $(document).find('.burger button');
		if (!$burger.length) return;

		var $toggleBbutton = $(document).find('.toggle-button');

		// Toggle sub-menus
		$toggleBbutton.on('click', function () {
			$(this).parent().toggleClass('menu-collapsed');
			$(this).toggleClass('tgl-active');
		});

		$burger.on('click', function () {
			$(this).toggleClass('active');
			$('nav.main ').toggleClass('mobile-active');

			$(this).toggleClass('show');

			const isActive = $(this).hasClass('active');
			$(this).attr('aria-expanded', isActive ? 'true' : 'false');
			$(this).attr('aria-label', isActive ? 'Stäng huvudmeny' : 'Öppna huvudmeny');

			if (isActive) {
				$(this).find('span:first-of-type').text('Stäng');
			} else {
				$(this).find('span:first-of-type').text('Meny');
			}
		});
	},
	initSideNav() {
		var $sidebarNav = $(document).find('#sortimentNav');
		if (!$sidebarNav.length) return;

		// Toggle sub-menus
		$sidebarNav.on('click', '.toggle-sub', function () {
			const icon = $(this).find('i');
			const isOpening = icon.hasClass('fa-plus');

			$(this).attr('aria-expanded', isOpening ? 'true' : 'false');

			if (isOpening) {
				icon.removeClass('fa-plus');
				icon.addClass('fa-minus');
				icon.parent().parent().addClass('current-page-parent');
				icon.parent().parent().addClass('current-page-item');
				$(this).addClass('active');
			} else {
				icon.removeClass('fa-minus');
				icon.addClass('fa-plus');
				icon.parent().parent().removeClass('current-page-parent');
				icon.parent().parent().removeClass('current-page-item');
				$(this).removeClass('active');
			}
		});
	},
};

export default Nav;
